__turbopack_context__.v({
  "column": "s1oVlG_column",
});
